export default function Error() {
  return (
    <main style={{padding: '1rem'}}>
      <h2>Error</h2>
      <p>There is nothing here!</p>
    </main>
  );
}
